defaultTimeout = if process.env.NODE_ENV == 'production' then 0 else 1000

module.exports = (timeout = defaultTimeout) ->
	new Promise (resolve) ->
		setTimeout resolve, timeout



// WEBPACK FOOTER //
// ./frontend/olos/js/lib/slow.coffee